import { CustomerAccountSelector } from './src/index';
import { WithHashChange } from './src/with-hashchange';
import { WithOldUIHeader } from './src/with-header';
import { DummyCustomerAccountSelector } from './src/dummy-customer-account-selector';

// TODO: Implement Account Selector with React Router
const CustomerAccountSelectorTreeView = WithHashChange(CustomerAccountSelector);
const CustomerAccountSelectorTreeViewWithHeader = WithOldUIHeader(CustomerAccountSelectorTreeView);

export {
  CustomerAccountSelector,
  CustomerAccountSelectorTreeView,
  CustomerAccountSelectorTreeViewWithHeader,
  DummyCustomerAccountSelector,
};
